import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usuariosmx'
})
export class UsuariosmxPipe implements PipeTransform {

  transform(value: any): any {
    const resultPost = [];
    for ( const post of value) {

      let cadenarole = post.role;
      let resultante: number= cadenarole.indexOf("PORTFISHING")
      if (resultante > 0) {
        resultPost.push (post);
      }
      

    

  }
  return resultPost;
  }

}
